<script setup lang="ts">
import type { NuxtLinkProps } from "#app";

defineProps<{
  text: string;
  linkLabel: string;
  linkTo: NuxtLinkProps["to"];
}>();
</script>

<template>
  <NuxtLink :to="linkTo" class="group flex w-full flex-col gap-m rounded-md bg-seagreen-50 px-l py-m no-underline transition-colors duration-300 hover:bg-seagreen-40 sm:flex-row">
    <div class="flex flex-col justify-between gap-xs">
      <p class="font-headline text-2xl leading-9 text-white" v-text="text" />

      <div class="flex items-center gap-s py-xs text-base leading-6 font-semibold text-yellow-20 no-underline">
        {{ linkLabel }}

        <UIcon name="fal:arrow-right-long" class="transition-transform duration-300 group-hover:translate-x-4" />
      </div>
    </div>

    <StaticAsset
      folder="graphics"
      file="packet-shapes.svg"
      class="translate-y-m px-[37px] xs:px-[130px]"
    />
  </NuxtLink>
</template>
